export class IncontactAuthContext {
  constructor() {
    let auth = JSON.parse(sessionStorage.getItem("auth"));
    if (auth !== undefined && auth !== null) {
      this.accessToken = auth.accessToken;
      this.refreshToken = auth.refreshToken;
      this.validUntil = auth.validUntil;
      this.tokenType = auth.tokenType;
      this.tokenUrl = auth.tokenUrl;
      this.apiEndpoint = auth.apiEndpoint;
      this.idToken = auth.idToken;
      this.logoutUrl = auth.logoutUrl;
      this.agentId = auth.agentId;
      this.apiExpiration = auth.apiExpiration;
      this.userInfo = auth.userInfo;
    }
  }

  save() {
    sessionStorage.setItem("auth", JSON.stringify(this));
  }

  remove() {
    sessionStorage.removeItem("auth");
  }
}
